import { Outlet, createFileRoute } from '@tanstack/react-router';

import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';

import { ValuesLogo } from './-components/ValuesLogo';

export const Route = createFileRoute('/_stacktrace/values/_layout')({
  component: Layout,
});

/**
 * 価値（Product Central > 価値）一覧のレイアウト。
 *
 * タブ構成: 概要 / 価値 / 設定。概要・設定は disabled の予約タブ。
 * 並びは products / test-sets / issues と同じパターン。
 */
function Layout() {
  const { t } = useTranslation();
  const { t: tStacktrace } = useTranslation(stacktraceNS);
  useDocumentTitle(tStacktrace('values.list.pageTitle'));

  const tabs = [
    {
      to: '/values/overview' as never,
      children: t('common.list.overview'),
      disabled: true,
      activeOptions: { exact: true },
    },
    {
      to: '/values',
      children: tStacktrace('values.list.pageTitle'),
      activeOptions: { exact: true },
    },
    {
      to: '/values/alerts' as never,
      children: t('common.list.alerts'),
      disabled: true,
      activeOptions: { exact: true },
    },
    {
      to: '/values/operation-activity' as never,
      children: t('common.list.operationActivity'),
      disabled: true,
      activeOptions: { exact: true },
    },
    {
      to: '/values/rules-and-policy' as never,
      children: t('common.list.configuration'),
      disabled: true,
      activeOptions: { exact: true },
    },
    {
      to: '/values/settings' as never,
      children: t('common.list.settings'),
      disabled: true,
      activeOptions: { exact: true },
    },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div className="flex flex-col h-full">
      <ProductHeader
        Logo={ValuesLogo}
        name={tStacktrace('values.list.pageTitle')}
        tabs={tabs}
        type="resource"
      />
      <Outlet />
    </div>
  );
}
